jQuery( document ).ready(function() {
  //start ready
  
  $('.flickity-button').click(function(event){
    target = event.target;
    var parent = $(target).parent();
    //this is used on PDP, hopefully it does not cause chaos to other sliders
    $(parent).addClass('is-moving');
    //Flickity will auto remove this when motion stops
  });
  
  //end ready
});


$(document).on('lazybeforesizes', function(e){
    //Force smaller images on mobile
    let window_width = $( window ).width();
    if(window_width < 720){
      e.detail.width = Math.min(window_width, Math.round(e.detail.width * 0.4));
    }
});